import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AdminService } from 'app/admin/admin.service';
import { VMwareProducts } from 'app/models/vmwareproducts';
import { ReportsService } from 'app/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss']
})
export class AddProductComponent implements OnInit {

  matchedRMproducts: Array<any> = [];
  timer: any;
  status: boolean = true;
  hideProductsForm: boolean = true;
  hideGrid: boolean = false;
  formSubmitted: boolean = false;
  readonly autoCompleteListLimit = 5;
  loader: boolean = true;
  subscriptions: Array<Subscription> = [];
  private addProductForm: FormGroup = new FormGroup({
    "productName": new FormControl('', Validators.required),
    "rmVmwProductId": new FormControl('', Validators.required),
    "description": new FormControl('', Validators.required)
  })
  private loaderAlertType: string = "alert-info";
  private vmwareProductsError: string = "";
  private showAlert: boolean = false;
  private products: Array<any> = [];
  private subs: Array<Subscription> = [];
  private productsList: Array<any> = [];

  constructor(private reportsService: ReportsService, private adminService: AdminService) { }

  get product(): FormGroup {
    return <FormGroup>this.addProductForm.get("product");
  }

  ngOnInit() {
    this.fetchProducts();
  }

  fetchMatchingProducts(event) {
    if (event) {
      let enteredText: string = event.target.value;
      if (enteredText.length > 3) {
        this.reportsService.getMatchingProducts(enteredText).subscribe(
            products =>{
              this.matchedRMproducts = products.objects;
            }
          )
      }
    }
  }

  updateRMId(event) {
    this.addProductForm.get('rmVmwProductId').setValue(0);
    //this.addProductForm.get('rmVmwProductId').setValue(
    //this.matchedRMproducts.filter((ele) => { return ele.name == event.target.value })[0].id);
  }

  resetForm() {
    this.addProductForm.reset();
    this.reportsService.getMatchingProducts(undefined);
    this.matchedRMproducts = [];
  }

  fetchProducts(){
    let sub = this.reportsService.getProducts(null).subscribe(
      products =>{
        this.products = products.sort((a, b) =>{
          return b.lastUpdate - a.lastUpdate
        });
      });
    this.products.push(sub);
  }

  onSubmit(){
    let productReq= new VMwareProducts();
    productReq.rmVmwProduct = this.addProductForm.get("productName").value;
    productReq.rmVmwProductId = this.addProductForm.get("rmVmwProductId").value;
    productReq.decription = this.addProductForm.get("description").value;
    productReq.support = true;
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    productReq.updatedBy = currentUser.email;
    let sub = this.adminService.addProducts(productReq).subscribe(
      (response)=>{
        this.resetForm();
        this.showAlertMessage("Successfully added the product","alert-success");
        this.fetchProducts();
      }
    )
    this.subs.push(sub)
  }

  showAlertMessage(message: string, alertType: string){
    this.vmwareProductsError = message;
    this.loaderAlertType = alertType;
    this.showAlert = true;
    setTimeout(() => {
      this.showAlert = false;
    }, 3000);
  }

  addNewProduct(){
    this.hideGrid = true;
    this.hideProductsForm = false;
    this.resetForm();
  }
}


// WEBPACK FOOTER //
// ./src/app/add-product/add-product.component.ts